export const roles: string[] = ["vositachi", "direktor", "admin", "skladchi"];
